import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { getTickets } from '../../../service/api/ticket/getTickets';
import { ticketDetailsApi } from '../../../service/api/ticket/getTicketDetails';
import ResponceToaster from '../../../jsx/components/responceToaster/responceToaster';
import { getNotesPurchaseListCallSCountersApi } from '../../../service/api/ticket/getNotesPurchaseListCallSCounters';
import emptyListImg from '../../../media/images/servicesAssets/emptyListImg.png'
import { callNoteDetails } from '../../../service/api/callHistory/callNoteDetails';
import ImagePreviewer from '../../../jsx/components/imagePreviewer/imagePreviewer';
import { Modal, OverlayTrigger, Tooltip } from 'react-bootstrap';
import InputField from '../../../jsx/components/fields/inputField';
import PrimaryButton from '../../../jsx/components/button/primaryButton';
import TextArea from '../../../jsx/components/fields/textArea';
import createBidApi from '../../../service/api/ticket/createBid';
import SkeletonForServices from '../../../component/skeletonTableRow/skeletonForServices';
import SkeletonDivElement from '../../../component/skeletonTableRow/skeletonDivElement';
import { getCallRecordingsApi } from '../../../service/api/video/getCallRecordings';
import createTicketThreadApi from '../../../service/api/ticket/createTicketThread';
import { getTicketMessageThreadApi } from '../../../service/api/ticket/getTicketMessageThread';
import deleteTicketThreadByIdApi from '../../../service/api/ticket/deleteTicketThreadById';
import updateTicketTicketThreadApi from '../../../service/api/ticket/updateTicketThreadById';
import hideServiceRequestApi from '../../../service/api/ticket/hideServiceRequest';
import { RiRefreshFill } from 'react-icons/ri';



const LocalProDashboard = () => {
    const { role, permissionArr, isVerified, isAvailable, isSubscribedUser, serviceRequestFlagPro } = useSelector((state) => state.user);
    const dispatch = useDispatch();

    const [elements, setElements] = useState([]);
    const [totalNoRecord, setTotalNoRecord] = useState(100);
    const [page, setPage] = React.useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [totalPage, setTotalPage] = useState(1);
    const [sortByValue, setSortByValue] = useState("DESC");
    const [searchValue, setSearchValue] = useState("");
    const [skeltonVal, setSkeltonVal] = useState(false);
    const [customeSkeletonLoading, setCustomeSkeletonLoading] = useState(false);
    const [isMore, setIsMore] = useState(true);
    const [serviceId, setServiceId] = useState('');

    const [serviceDetailsLoading, setServiceDetailsLoading] = useState(false);
    const [receiverData, setReceiverData] = useState({});
    const [attachmentsArr, setAttachmentsArr] = useState([]);
    const [productCategorySearch, setProductCategorySearch] = useState("")
    const [time, setTime] = useState(0);
    const [updatedTime, setUpdatedTime] = useState(0);
    const [imageLoader, setImageLoader] = useState(true);
    const [timeSlotArr, setTimeSlotArr] = useState([]);
    const [timeSlotID, setTimeSlotID] = useState(4);
    const [communicationModeID, setCommunicationModeID] = useState(3);
    const [communicationModeArr, setCommunicationModeArr] = useState([]);
    const [productCategory, setProductCategory] = useState("");
    const [description, setDescription] = useState("");
    const [modelNum, setModelNum] = useState("");
    const [brandName, setBrandName] = useState("");
    const [serialNumber, setSerialNumber] = useState("");
    const [serviceSummaryMetaData, setServiceSummaryMetaData] = useState({});


    const [responceMsg, setResponceMsg] = useState("");
    const [updateDocumentsLoading, setUpdateDocumentsLoading] = useState(false);
    const [toasterType, setToasterType] = useState();
    const [handleToaster, setHandleToaster] = useState(false);

    const [localProTabs, setLocalProTabs] = useState(1);
    const [callNoteDetailsArr, setCallNoteDetailsArr] = useState([]);

    const [openDoc, setOpenDoc] = React.useState(false);
    const [imageAttach, setImageAttach] = useState(1);
    const [imageAttachURL, setImageAttachURL] = useState('');
    const [notesMessage, setNotesMessage] = useState("");

    const [scale, setScale] = useState(1);
    const [position, setPosition] = useState({ x: 0, y: 0 });
    const [dragging, setDragging] = useState(false);

    const [discussionLoading, setDiscussionLoading] = useState(false);

    const [createBidModalTrigger, setCreateBidModalTrigger] = useState(false);

    const [currentDateLocalPro, setCurrentDateLocalPro] = useState('');
    const [currentTimeLocalPro, setCurrentTimeLocalPro] = useState('');

    const [termsAndConditions, setTermsAndConditions] = useState(localStorage.getItem('projectId') ? true : false);
    const [termsAndConditionsErr, setTermsAndConditionsErr] = useState(false);
    const [bidNotes, setBidNotes] = useState("");
    const [bidPriceMax, setBidPriceMax] = useState(``);
    const [availabilityUnixTime, setAvailabilityUnixTime] = useState(0);

    const [isBidPriceError, setIsBidPriceError] = useState(false);
    const [isBidNotesError, setIsBidNotesError] = useState(false);

    const [createBidLoading, setCreateBidLoading] = useState(false);
    const [getServicesLoading, setGetServicesLoading] = useState(false);

    const [isCallRecording, setIsCallRecordings] = useState(true);
    const [callLogIdsArr, setCallLogIdsArr] = useState([]);
    const [getCallRecordingsLoading, setGetCallRecordingsLoading] = useState(false);
    const [callRecordingsArr, setCallRecordingsArr] = useState([]);
    const [getComposeRecordingsLoading, setGetComposeRecordingsLoading] = useState(false);

    const [askQuestionModalTrigger, setAskQuestionModalTrigger] = useState(false);
    const [questionDescription, setQuestionDescription] = useState("");
    const [questionDescriptionErr, setQuestionDescriptionErr] = useState(false);
    const [createTicketThreadLoading, setCreateTicketThreadLoading] = useState(false);
    const [ticketMessageThreadArr, setTicketMessageThreadArr] = useState([]);
    const [getTicketMessageThreadLoading, setGetTicketMessageThreadLoading] = useState(false);
    const [ticketThreadObj, setTicketThreadObj] = useState({});
    const [deleteTicketThreadLoading, setDeleteTicketThreadLoading] = useState(false);
    const [tabsToggleForAskQuestion, setTabsToggleForAskQuestion] = useState(1);

    const [hideServiceRequestLoading, setHideServiceRequestLoading] = useState(false);
    const [hideServiceRequestModalTrigger, setHideServiceRequestModalTrigger] = useState(false);

    const [bidStatus, setBidStatus] = useState("");

    const [firstLoadForServices, setFirstLoadForServices] = useState(true);

    const handleOpenAskQuestionModal = () => {
        setAskQuestionModalTrigger(true);
    }

    const handleCloseAskQuestionModal = () => {
        setAskQuestionModalTrigger(false);
        setQuestionDescription("");
        setQuestionDescriptionErr(false);
        setTicketMessageThreadArr([]);
        setTabsToggleForAskQuestion(1);
    }

    const handleQuestionDescription = (e) => {
        setQuestionDescriptionErr(false);
        setQuestionDescription(e.target.value);
    }

    const handelOpenCreateBidModal = () => {
        setCreateBidModalTrigger(true);
    }

    const handelCloseCreateBidModal = () => {
        setCreateBidModalTrigger(false);
        handleClearBidData();
    }

    const handleBidPriceMax = (e) => {
        setIsBidPriceError(false);
        setBidPriceMax(e.target.value.replace(/\D/g, ''));
    }

    const handleBidNotes = (e) => {
        setIsBidNotesError(false);
        setBidNotes(e.target.value);
    }

    const getCallHistoryDetails = (res) => {
        // Currently pagination is hidden
        // const newElements = [...elements, ...res.data];
        // const uniqueElements = Array.from(
        //     new Set(newElements.map(JSON.stringify))
        // ).map(JSON.parse);
        // setElements(uniqueElements);

        setElements(res.data);


        setTotalNoRecord(res.total_count);
        if (res.total_count % pageSize === 0) {
            setTotalPage(parseInt(res.total_count / pageSize));
        } else {
            setTotalPage(parseInt(res.total_count / pageSize + 1));
        }

        if (res.total_count === 0) {
            setTimeout(() => {
                setSkeltonVal(true);
            }, "3000");
        } else {
            setSkeltonVal(true);
        }

        // console.log(parseInt(res.total_records / pageSize), 'quoitent')
    };

    const onLoadData = () => {
        setCustomeSkeletonLoading(true);
        setGetServicesLoading(true);
        let allTickets = new FormData();

        allTickets.append("page_index", page);
        // allTickets.append("page_size", pageSize);
        allTickets.append("page_size", 100);
        allTickets.append("pagination_flag", 1);
        allTickets.append("sorting_order", sortByValue);
        allTickets.append("sorting_column_name", '');
        allTickets.append("search_area", searchValue);
        allTickets.append("assigned_flag_ysn", 0);
        allTickets.append("is_local_pro_tickets_flag", 1);
        allTickets.append("ticket_status_int", 2);

        setIsMore(false);
        dispatch(
            getTickets(allTickets, (res) => {
                if (res.data?.length !== 0) {
                    setIsMore(true);
                }
                getCallHistoryDetails(res);
                setCustomeSkeletonLoading(false);
                setGetServicesLoading(false);
            }, () => {
                setCustomeSkeletonLoading(false);
                setGetServicesLoading(false);
            })
        );

        // return;
    };

    const autoRefreshServiceListing = () => {
        // setCustomeSkeletonLoading(true);
        // setGetServicesLoading(true);
        let allTickets = new FormData();

        allTickets.append("page_index", page);
        // allTickets.append("page_size", pageSize);
        allTickets.append("page_size", 100);
        allTickets.append("pagination_flag", 1);
        allTickets.append("sorting_order", sortByValue);
        allTickets.append("sorting_column_name", '');
        allTickets.append("search_area", searchValue);
        allTickets.append("assigned_flag_ysn", 0);
        allTickets.append("is_local_pro_tickets_flag", 1);
        allTickets.append("ticket_status_int", 2);

        setIsMore(false);
        dispatch(
            getTickets(allTickets, (res) => {
                if (res.data?.length !== 0) {
                    setIsMore(true);
                }
                getCallHistoryDetails(res);
                // setCustomeSkeletonLoading(false);
                // setGetServicesLoading(false);
            }, () => {
                // setCustomeSkeletonLoading(false);
                // setGetServicesLoading(false);
            })
        );

        // return;
    };

    useEffect(() => {
        onLoadData();
    }, [
        pageSize,
        page,
    ]);

    // Auto refresh the list after 10 seconds
    useEffect(() => {
        if (!firstLoadForServices) {
            autoRefreshServiceListing();
        }

        const intervalId = setInterval(() => {
            autoRefreshServiceListing();
        }, 10000); // every 10 seconds

        return () => {
            clearInterval(intervalId); // cleanup
        };
    }, []);

    useEffect(() => {
        // if (elements.length > 0 && firstLoadForServices) {
        //     if (elements[0]?.is_composed_video_flag == 1) {
        //         setServiceId(elements[0]?.ticket_id_ids);
        //     }
        //     setFirstLoadForServices(false);
        // }
        if (elements.length > 0 && firstLoadForServices) {
            const firstComposedVideo = elements.find(
                (element) => element?.is_composed_video_flag == 1
            );
            if (firstComposedVideo) {
                setServiceId(firstComposedVideo?.ticket_id_ids);

                let bidsData = JSON.parse(firstComposedVideo?.bids_data) || [];
                const myBid = bidsData.find((bid) => bid?.bid_user_id === localStorage.getItem("user_id"));

                setBidStatus(myBid?.bid_status_int || "");
            }
            setFirstLoadForServices(false);
        }
    }, [elements]);

    useEffect(() => {
        // console.log(serviceId, "serviceId");
        if (serviceId) {
            getNotesPurchaseListCallSCountersFn();
            particularTicketDetails();
        }
    }, [serviceId]);

    const particularTicketDetails = () => {

        setServiceDetailsLoading(true)

        let details = {
            ticket_id_ids: serviceId,
        };
        dispatch(
            ticketDetailsApi(details, (res) => {
                setServiceDetailsLoading(false);

                // console.log(res);
                // console.log(res?.data?.calls, "calls data in details api");

                // res?.data?.call_log_data_for_ticket?.map((item, index) => {
                //     setCallLogIdsArr(prev => [...prev, item.call_log_id_ids]);
                // });
                setCallRecordingsArr([]);

                if (res?.data?.call_log_data_for_ticket[0]?.call_log_id_ids) {
                    handleCallRecordingsFn(res?.data?.call_log_data_for_ticket[0]?.call_log_id_ids);
                }

                setIsCallRecordings(false);

                setReceiverData(res?.data);
                setAttachmentsArr(res?.data?.attachment_data);
                setProductCategorySearch(res?.data?.product_type_chr);
                setTime(res?.data?.created_date_dtm + "000");
                setUpdatedTime(res?.data?.updated_date_dtm + "000");
                setImageLoader(false);

                setTimeSlotArr(res?.time_slot);
                res?.data?.time_slot_id && setTimeSlotID(res?.data?.time_slot_id);

                setCommunicationModeArr(res?.communication_mode);
                res?.data?.communication_mode_id && setCommunicationModeID(res?.data?.communication_mode_id);
                setProductCategory(res.data.category_name_chr);

                res?.data?.problem_description_chr && setDescription(res?.data?.problem_description_chr);
                res?.data?.model_number_chr && setModelNum(res?.data?.model_number_chr);
                localStorage.setItem("proType", res?.data?.product_type_chr);

                res?.data?.serial_number_chr && setSerialNumber(res?.data?.serial_number_chr);
                res?.data?.device_brand_chr && setBrandName(res?.data?.device_brand_chr);
                // dispatch(setLoaderTime(res))

                if (res?.data?.summary_meta_data) {

                    // debugger;
                    // const finalObject = JSON.parse(JSON.parse(res?.data?.summary_meta_data));
                    // const finalObjectTwo = (JSON.parse(res?.data?.summary_meta_data));

                    const finalObjectTwo = (JSON.parse(res?.data?.summary_meta_data));

                    let finalObject = {};

                    // if(!Object.keys(finalObjectTwo).length > 0) {
                    if (typeof (finalObjectTwo) === 'string') {
                        finalObject = JSON.parse(finalObjectTwo);
                    }


                    // console.log(finalObject, "finalObject");
                    // console.log(finalObjectTwo, "finalObjectTwo");

                    if (Object.keys(finalObject).length > 0) {
                        setServiceSummaryMetaData(finalObject);

                    } else if (Object.keys(finalObjectTwo).length > 0) {
                        setServiceSummaryMetaData(finalObjectTwo);

                    } else {
                        setServiceSummaryMetaData({});
                    }

                }
            }, (err) => {
                setServiceDetailsLoading(false);
                setResponceMsg(err.data.message);

                setToasterType("error");

                setHandleToaster(true);
                setTimeout(() => {
                    setHandleToaster(false);
                }, 11000);
            })
        );
    };

    useEffect(() => {
        if (callLogIdsArr?.length > 0) {
            callLogIdsArr?.map((item, index) => {
                // console.log(item, "call log ids");
                handleCallRecordingsFn(item)
            })
        }
    }, [callLogIdsArr]);


    const handleCallRecordingsFn = (callLogId) => {
        if (callLogId) {
            setGetCallRecordingsLoading(true);
            setGetComposeRecordingsLoading(true);
            let details = {
                call_log_id: callLogId,
                page_index: 1,
                page_size: 1000,
                sorting_order: 'DESC',
                // sorting_column_name: columnName,
                // search_area: searchValue,
            };

            dispatch(
                getCallRecordingsApi(details, (res) => {
                    // setElements(res.data.data);
                    setGetCallRecordingsLoading(false);
                    //    console.log(res?.data?.data, 'call recordings data')

                    setCallRecordingsArr(prevState => [...prevState, res?.data?.data[0]]);


                }, (err) => {
                    setGetCallRecordingsLoading(false);
                })
            );


            // Composed recordings are combined in getCallRecordingsApi itself
            // dispatch(
            //     getComposeRecordingsApi(details, (res) => {
            //         console.log(res?.data?.data, 'compose recordings data')
            //         // setElements(res.data.data);
            //         //    console.log(res?.data?.data, 'call recordings data')
            //         setGetComposeRecordingsLoading(false);
            //         setComposeRecordingsArr(prevState => [...prevState, res?.data?.data[0]]);

            //     }, (err) => {
            //         setGetComposeRecordingsLoading(false);
            //     })
            // );
        }
    }

    const [notesCount, setNotesCount] = useState(0);
    const getNotesPurchaseListCallSCountersFn = () => {
        // if (serviceId) {
        //     return
        // }
        let data = {
            ticket_id_ids: serviceId,
        }
        dispatch(getNotesPurchaseListCallSCountersApi(data,
            (res) => {
                // console.log(res.data, "counters")
                // setCallCount(res.data?.call_count || 0);
                // setNotPurchasedShoppingItemCount(res.data?.not_purchased_shopping_item_count || 0);
                // setServiceReqHistoryCount(res.data?.service_request_history_count || 0);
                setNotesCount(res.data?.notes_count || 0);
            }, (err) => {
                console.log(err)
            }
        ))
    }

    // Format the price to USD 
    let USDollar = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
    });

    // Format the unix time in given format
    function formatUnixTimestamp(unixTimestamp) {
        const date = new Date(unixTimestamp * 1000);

        const month = date.toLocaleString('default', { month: 'short' });
        const day = date.getDate();
        let hour = date.getHours();
        const minute = date.getMinutes();

        const hourFormatted = hour % 12 || 12; // Convert 24-hour time to 12-hour format
        const amPm = hour < 12 ? 'am' : 'pm';
        const minuteFormatted = minute < 10 ? `0${minute}` : minute;

        return `${month} ${day}, ${hourFormatted}:${minuteFormatted} ${amPm}`;
    }

    const handleOpenDoc = () => {
        setOpenDoc(true);
    }

    const handleResetImage = () => {
        setScale(1);
        setPosition({ x: 0, y: 0 });
    }

    const handleCloseDoc = () => {
        setOpenDoc(false);
        handleResetImage();
        setNotesMessage('');
    }

    const callNoteData = () => {
        setDiscussionLoading(true);
        let data = new FormData();

        data.append("user_id_ids", localStorage.getItem("user_id"));
        // data.append("call_log_id_ids", localStorage.getItem("call_log_id"));
        data.append("ticket_id_ids", serviceId);

        data.append("page_index", 1);
        data.append("page_size", 25);
        data.append("sorting_order", "DESC");
        data.append("sorting_column_name", "");
        data.append("search_area", '');

        dispatch(
            callNoteDetails(data, (res) => {
                setCallNoteDetailsArr(res.data.data);
                setDiscussionLoading(false);
                getNotesPurchaseListCallSCountersFn();
            })
        );
    };

    const handleSubmitCreateBid = (e) => {
        e.preventDefault();
        if (!termsAndConditions) {
            setTermsAndConditionsErr(true);
        }
        if (!bidPriceMax) {
            setIsBidPriceError(true);
        }
        if (!bidNotes) {
            setIsBidNotesError(true);
        }

        if (termsAndConditions && bidPriceMax && bidNotes) {
            setCreateBidLoading(true);

            const data = new FormData();
            data.append("ticket_id", serviceId);
            data.append("price_type", 'FIXED');
            data.append("price_max", parseInt(bidPriceMax));
            data.append("availability_unix_datetime_stamp", availabilityUnixTime);
            data.append("what_is_included", bidNotes);

            dispatch(
                createBidApi(data, (res) => {
                    setCreateBidLoading(false);
                    handelCloseCreateBidModal();
                    setBidStatus(res?.data?.data[0]?.status_int_ysn);
                    onLoadData();

                    setElements([]);

                    setResponceMsg(res.data.message);

                    // setToasterType("success");

                    // setHandleToaster(true);
                    // setTimeout(() => {
                    //     setHandleToaster(false);
                    // }, 11000);

                }, (err) => {
                    setCreateBidLoading(false);
                    setResponceMsg(err.data.message);

                    setToasterType("error");

                    setHandleToaster(true);
                    setTimeout(() => {
                        setHandleToaster(false);
                    }, 11000);
                })
            );
        }


    }

    const handleSetCurrentDateAndTime = () => {
        // Get the current date and time
        const now = new Date();
        const date = now.toISOString().split('T')[0]; // format yyyy-mm-dd for the date input

        // Set the time one hour ahead
        now.setHours(now.getHours() + 1);

        let hours = now.getHours();
        let minutes = now.getMinutes();

        // Adjust minutes to the nearest 30-minute slot
        minutes = minutes < 30 ? 0 : 30;

        // If minutes round up to 0 and it causes the hour to increase (e.g., 23:59 -> 00:00)
        if (minutes === 0 && now.getMinutes() >= 30) {
            hours += 1;
        }

        // Ensure two-digit formatting for hours and minutes
        hours = hours < 10 ? `0${hours}` : hours;
        minutes = minutes === 0 ? `00` : `30`;

        const time = `${hours}:${minutes}`;

        // Update the state
        // setCurrentDate(date);
        // setCurrentTime(time);

        setCurrentTimeLocalPro(time);
        setCurrentDateLocalPro(date);
    };

    useEffect(() => {
        handleSetCurrentDateAndTime();
    }, []);

    useEffect(() => {
        // console.log(currentDateLocalPro, currentTimeLocalPro, "currentDateLocalPro, currentTimeLocalPro");

        if (currentDateLocalPro && currentTimeLocalPro) {
            const [year, month, day] = currentDateLocalPro.split("-").map(Number);
            const [hour, minute] = currentTimeLocalPro.split(":").map(Number);

            // console.log(Math.floor(
            //     new Date(year, month - 1, day, hour, minute).getTime() / 1000
            // ))

            setAvailabilityUnixTime(Math.floor(
                new Date(year, month - 1, day, hour, minute).getTime() / 1000
            ));
        }

    }, [currentDateLocalPro, currentTimeLocalPro]);

    const handleClearBidData = () => {
        setBidPriceMax("");
        setBidNotes("");
        setIsBidPriceError(false);
        setIsBidNotesError(false);
    };

    const handleCreateTicketThread = (e) => {
        e.preventDefault();
        if (!questionDescription) {
            setQuestionDescriptionErr(true);
        }


        if (questionDescription) {
            setCreateTicketThreadLoading(true);

            const data = new FormData();
            data.append("ticket_id", serviceId);
            data.append("message_body", questionDescription);

            dispatch(
                createTicketThreadApi(data, (res) => {
                    setCreateTicketThreadLoading(false);
                    handleCloseAskQuestionModal();


                    setResponceMsg(res.data.message);

                    // setToasterType("success");

                    // setHandleToaster(true);
                    // setTimeout(() => {
                    //     setHandleToaster(false);
                    // }, 11000);

                }, (err) => {
                    setCreateTicketThreadLoading(false);
                    setResponceMsg(err.data.message);

                    setToasterType("error");

                    setHandleToaster(true);
                    setTimeout(() => {
                        setHandleToaster(false);
                    }, 11000);
                })
            );
        }
    }

    const handleGetTicketMessageThread = () => {
        setGetTicketMessageThreadLoading(true);

        const data = new FormData();
        data.append("ticket_id", serviceId);
        data.append("sorting_order", 'DESC');

        dispatch(
            getTicketMessageThreadApi(data, (res) => {
                setGetTicketMessageThreadLoading(false);
                setTicketMessageThreadArr(res.data);

                setResponceMsg(res.data.message);

                // setToasterType("success");

                // setHandleToaster(true);
                // setTimeout(() => {
                //     setHandleToaster(false);
                // }, 11000);

            }, (err) => {
                setGetTicketMessageThreadLoading(false);
                setResponceMsg(err.data.message);

                setToasterType("error");

                setHandleToaster(true);
                setTimeout(() => {
                    setHandleToaster(false);
                }, 11000);
            })
        );
    }

    // Delete ticket thread by id
    const handleDeleteTicketThreadById = () => {
        setDeleteTicketThreadLoading(true);

        let details = {
            ticket_id_ids: serviceId,
            ticket_message_thread_id: ticketThreadObj?.thread_messages_id_ids,
        };

        dispatch(
            deleteTicketThreadByIdApi(details, (res) => {
                setDeleteTicketThreadLoading(false);

                setResponceMsg(res.data.message);

                setTicketThreadObj({});
                setTabsToggleForAskQuestion(2);

                handleGetTicketMessageThread();

                // setToasterType("success");
                // setHandleToaster(true);
                // setTimeout(() => {
                //     setHandleToaster(false);
                // }, 11000);

            }, (err) => {
                setDeleteTicketThreadLoading(false);
                setResponceMsg(err.data.message);

                setToasterType("error");

                setHandleToaster(true);
                setTimeout(() => {
                    setHandleToaster(false);
                }, 11000);
            })
        );
    }

    // update ticket thread by id
    const handleUpdateTicketThreadById = (e) => {
        e.preventDefault();
        if (!questionDescription) {
            setQuestionDescriptionErr(true);
        }

        if (questionDescription) {
            setCreateTicketThreadLoading(true);

            const data = new FormData();
            data.append("ticket_message_thread_id", ticketThreadObj?.thread_messages_id_ids);
            data.append("message_body", questionDescription);

            dispatch(
                updateTicketTicketThreadApi(data, (res) => {
                    setCreateTicketThreadLoading(false);

                    setTicketThreadObj({});
                    setTabsToggleForAskQuestion(2);
                    setQuestionDescription("");

                    handleGetTicketMessageThread();

                    setResponceMsg(res.data.message);

                    // setToasterType("success");
                    // setHandleToaster(true);
                    // setTimeout(() => {
                    //     setHandleToaster(false);
                    // }, 11000);
                }, (err) => {
                    setCreateTicketThreadLoading(false);
                    setResponceMsg(err.data.message);

                    setToasterType("error");

                    setHandleToaster(true);
                    setTimeout(() => {
                        setHandleToaster(false);
                    }, 11000);
                })
            );
        }
    }

    // Decline service request by local pro
    const hideSeriveRequestFn = () => {
        setHideServiceRequestLoading(true);
        const data = new FormData();

        data.append("ticket_id_ids", serviceId);
        data.append("sender_id_ids", localStorage.getItem("user_id"));
        data.append("reciever_id_ids", receiverData.user_id_lng);

        dispatch(
            hideServiceRequestApi(
                data,
                (res) => {
                    setResponceMsg(res.data.message);
                    // setHideServiceRequestLoading(false);
                    // ticketStatus();
                    // particularTicketDetails();
                    setToasterType("success");
                    // navigate('/callHistory')

                    onLoadData();

                    // setHandleToaster(true);
                    // setTimeout(() => {
                    //     setHandleToaster(false);
                    // }, 11000);

                },
                (res) => {

                    setHideServiceRequestLoading(false);
                    // particularTicketDetails();
                    setResponceMsg(res.data.message);
                    setToasterType("error");

                    setHandleToaster(true);
                    setTimeout(() => {
                        setHandleToaster(false);
                    }, 11000);

                }
            )
        );
    }

    // Super admin approve message 
    const handleSuperAdminApproveMessage = () => {
        setResponceMsg("Please wait for super admin approval. We will verify your details, before you can proceed.");
        setToasterType("info");

        setHandleToaster(true);
        setTimeout(() => {
            setHandleToaster(false);
        }, 11000);
    }

    const refreshList = (
        <Tooltip id="tooltip">
            <strong>
                {`Get latest incoming jobs.`}
            </strong>
        </Tooltip>
    );

    return (
        <>
            <div className="row mx-0">
                <div className="col-12 p-2 d-flex justify-content-center align-items-center">

                    <div className='row mx-0 w-100'>
                        <div className='col-sm-12 col-lg-3 ' style={{ minHeight: 'calc(100vh - 93px)' }}>
                            <div className=' rounded-2 bg-white  h-100 p-2'>
                                <div className='row'>
                                    <div className='col-12 d-flex justify-content-between align-items-center pb-2 border-bottom'>
                                        <span className='fs-4 font-w600 text-black'>{`Incoming Jobs`}</span>

                                        {/* <OverlayTrigger placement="top" overlay={refreshList}>
                                            <span
                                                className='cursor-pointer px-2 py-1 rounded-3 font-w600 text-hovered'
                                                onClick={() => {
                                                    // setElements([]);
                                                    autoRefreshServiceListing();
                                                    // setServiceId("");
                                                }}
                                                style={{ fontSize: '28px' }}
                                            >
                                                <RiRefreshFill />
                                            </span>
                                        </OverlayTrigger> */}
                                    </div>
                                </div>

                                <div
                                    className='overflow-auto pt-2'
                                    style={{
                                        maxHeight: 'calc(100dvh - 165px)'
                                    }}
                                >
                                    {getServicesLoading ?
                                        <>
                                            {[...Array(5)].map((data, id) => {
                                                return (
                                                    <>
                                                        <div key={id} className="row mx-1 shadow bg-white my-2" style={{ height: "", borderRadius: '16px' }}>
                                                            <div className="col-12 d-flex p-2">
                                                                <div className="w-100 h-100 d-flex flex-column justify-content-between ms-3">
                                                                    <div className="d-flex align-items-center justify-content-between mb-2">
                                                                        <div>
                                                                            <SkeletonDivElement height={'20px'} width={'90px'} borderRadius={'14px'} />
                                                                        </div>

                                                                        <div>
                                                                            <SkeletonDivElement height={'20px'} width={'90px'} borderRadius={'14px'} />
                                                                        </div>
                                                                    </div>

                                                                    <div>
                                                                        <div className="mb-2">
                                                                            <SkeletonDivElement height={'20px'} width={'30%'} borderRadius={'14px'} />
                                                                        </div>

                                                                        <div className="mb-2">
                                                                            <SkeletonDivElement height={'20px'} width={'50%'} borderRadius={'14px'} />
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </>
                                                )
                                            })}
                                        </> :
                                        <>
                                            {elements.length > 0 ?
                                                <>
                                                    {elements.map((item, index) => {
                                                        let summryMetaData = {};
                                                        if (item?.summary_meta_data) {

                                                            // debugger;
                                                            // const finalObject = JSON.parse(JSON.parse(res?.data?.summary_meta_data));
                                                            // const finalObjectTwo = (JSON.parse(res?.data?.summary_meta_data));


                                                            const finalObjectTwo = (JSON.parse(item?.summary_meta_data));

                                                            let finalObject = {};

                                                            // if(!Object.keys(finalObjectTwo).length > 0) {
                                                            if (typeof (finalObjectTwo) === 'string') {
                                                                finalObject = JSON.parse(finalObjectTwo);
                                                            }


                                                            // console.log(finalObject, "finalObject");
                                                            // console.log(finalObjectTwo, "finalObjectTwo");

                                                            if (Object.keys(finalObject).length > 0) {
                                                                summryMetaData = finalObject;
                                                                // setServiceSummaryMetaData(finalObject);
                                                                // setProRecommendedSolution(finalObject?.pro_check_info?.pro_recommended_solution || 0);
                                                                // setCustomerSelectedSolution(finalObject?.customer_check_info?.customer_selected_solution || 0);
                                                                // setProDiagnosis(finalObject?.pro_check_info?.pro_diagnosis || "");
                                                            } else if (Object.keys(finalObjectTwo).length > 0) {
                                                                summryMetaData = finalObjectTwo;
                                                                // setServiceSummaryMetaData(finalObjectTwo);
                                                                // setProRecommendedSolution(finalObjectTwo?.pro_check_info?.pro_recommended_solution || 0);
                                                                // setCustomerSelectedSolution(finalObjectTwo?.customer_check_info?.customer_selected_solution || 0);
                                                                // setProDiagnosis(finalObjectTwo?.pro_check_info?.pro_diagnosis || "");
                                                            } else {
                                                                // setServiceSummaryMetaData({});
                                                                summryMetaData = {};
                                                            }
                                                            //console.log(summryMetaData, "summryMetaData");
                                                        }
                                                        let bidsData = JSON.parse(item?.bids_data) || [];
                                                        const myBid = bidsData.find((bid) => bid?.bid_user_id === localStorage.getItem("user_id"));

                                                        // console.log(bidsData, "bidsData");
                                                        // console.log(myBid, "myBid");
                                                        return (
                                                            <>
                                                                {item?.is_composed_video_flag == 1 &&
                                                                    <>
                                                                        <div
                                                                            className='row' key={index}
                                                                            onClick={() => {
                                                                                setServiceId(item?.ticket_id_ids);
                                                                                setLocalProTabs(1);
                                                                                setCallNoteDetailsArr([]);
                                                                                setBidStatus(myBid?.bid_status_int || "");
                                                                            }}
                                                                        >
                                                                            <div
                                                                                className={`col-12 ${serviceId === item?.ticket_id_ids ? 'border-primary' : ''} cursor-pointer border-hovered rounded-2 px-3 py-2 my-1`}
                                                                                style={{
                                                                                    border: '1px solid grey',
                                                                                    borderLeft: serviceId === item?.ticket_id_ids ? '8px solid #e85c27' : '1px solid grey',
                                                                                }}
                                                                            >
                                                                                <div className='d-flex align-items-center mb-2 justify-content-between'>
                                                                                    <span className='fs-5 font-w600 text-black'>{`#${item?.display_id_int} `}</span>

                                                                                    <span
                                                                                        className='px-3 py-1 rounded-3 font-w600'
                                                                                        style={{
                                                                                            border: myBid?.bid_status_int == 1 ? '1px solid #2563eb' : myBid?.bid_status_int == 4 ? '1px solid #16a34a' : '1px solid #ff6b35',
                                                                                            color: myBid?.bid_status_int == 1 ? '#2563eb' : myBid?.bid_status_int == 4 ? '#16a34a' : '#ff6b35',
                                                                                            background: myBid?.bid_status_int == 1 ? 'rgba(37,99,235,.1)' : myBid?.bid_status_int == 4 ? 'rgb(22 163 74 / 23%)' : '#ffa50026'
                                                                                        }}
                                                                                    >
                                                                                        {myBid?.bid_status_int == 1 ? `QUOTED` : myBid?.bid_status_int == 4 ? `WON` : `NEW`}
                                                                                    </span>
                                                                                </div>

                                                                                <div className='d-flex'>
                                                                                    <span className=' text-black'>
                                                                                        Created on: {" "}
                                                                                        {/* {`${formatUnixTimestamp(element?.created_date_dtm)}`} */}
                                                                                        {new Intl.DateTimeFormat("en-US", {
                                                                                            year: "numeric",
                                                                                            month: "short",
                                                                                            day: "numeric",
                                                                                            hour: 'numeric',
                                                                                            minute: 'numeric',
                                                                                            hour12: true
                                                                                        }).format(
                                                                                            item?.created_date_dtm * 1000
                                                                                        )}
                                                                                    </span>
                                                                                </div>

                                                                                <div className='mb-2'>
                                                                                    <span className='fs-5 font-w600 text-black'>
                                                                                        {`${item.category_display_name_chr ? `${item.category_display_name_chr} :` : ''}
                                                        ${item.product_type_chr ? `${item.product_type_chr}` : ''}
                                                        `}
                                                                                    </span>
                                                                                </div>

                                                                                <div>
                                                                                    <span className='fs-5 font-w500 text-black'>{`${item.problem_description_chr ? item.problem_description_chr : 'Problem description not specified'}`}</span>
                                                                                </div>
                                                                                <div>
                                                                                    <span className='fs-5 font-w500'>
                                                                                        {`Customer would like it done ${summryMetaData?.estimated_by_customer?.date ? `by ${summryMetaData?.estimated_by_customer?.date}, ${summryMetaData?.estimated_by_customer?.time}` : 'ASAP'} `}
                                                                                    </span>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </>
                                                                }
                                                            </>
                                                        )
                                                    })}
                                                </> :
                                                <div className='row mx-2 fs-6 py-2 my-5'>
                                                    <div className='col-12 px-0 d-flex justify-content-center align-items-center flex-column'>
                                                        <img src={emptyListImg} style={{ width: "70px" }} alt="" />
                                                        <span className='mt-3 fs-5 text-center text-white fw-bold'>{"No notes added yet"}</span>
                                                    </div>
                                                </div>
                                            }
                                        </>
                                    }






                                </div>
                            </div>
                        </div>

                        <div className='col-sm-12 col-lg-6' style={{ minHeight: 'calc(100vh - 93px)' }}>
                            <div className='  bg-black h-100 p-2'>

                                <div className='row'>
                                    <div className='col-12 px-2 d-flex align-items-center my-2'>
                                        <span
                                            className='border d-flex font-w600 fs-5 fw-bold px-2 px-3 py-2 rounded-2 text-white me-2 cursor-pointer h-100 d-flex justify-content-center align-items-center border-hovered'
                                            style={{
                                                backgroundColor: localProTabs === 1 ? '#e85c27' : '#8080809e',
                                            }}
                                            onClick={() => {
                                                setLocalProTabs(1)
                                            }}
                                        >
                                            Video {`${callRecordingsArr?.length > 0 ? ` (1) ` : ''}`}
                                        </span>

                                        <span
                                            className='border d-flex font-w600 fs-5 fw-bold px-2 px-3 py-2 rounded-2 text-white me-2 cursor-pointer h-100 d-flex justify-content-center align-items-center border-hovered'
                                            style={{
                                                backgroundColor: localProTabs === 2 ? '#e85c27' : '#8080809e',
                                            }}
                                            onClick={() => {
                                                setLocalProTabs(2)
                                            }}
                                        >
                                            Images {`${attachmentsArr?.length > 0 ? ` (${attachmentsArr?.length}) ` : ''}`}
                                        </span>

                                        <span
                                            className='border d-flex font-w600 fs-5 fw-bold px-2 px-3 py-2 rounded-2 text-white me-2 cursor-pointer h-100 d-flex justify-content-center align-items-center border-hovered'
                                            style={{
                                                backgroundColor: localProTabs === 3 ? '#e85c27' : '#8080809e',
                                            }}
                                            onClick={() => {
                                                setLocalProTabs(3);
                                                callNoteData();
                                            }}
                                        >
                                            Notes {`${notesCount > 0 ? ` (${notesCount}) ` : ''}`}
                                        </span>

                                    </div>
                                </div>

                                <div
                                    className='overflow-auto'
                                    style={{
                                        maxHeight: 'calc(100dvh - 150px)'
                                    }}
                                >

                                    {
                                        localProTabs === 1 ?
                                            <>
                                                <div className='row mt-2'>
                                                    <div className='col-12 px-0'>
                                                        <div className='row mx-0 overflow-auto pb-5'
                                                            style={{
                                                                //  minHeight: "300px", 
                                                                //  maxHeight: "300px",  

                                                            }}
                                                        >
                                                            {callRecordingsArr[0]?.composed_recording?.length > 0 ?
                                                                <>
                                                                    {callRecordingsArr[0]?.composed_recording[0]?.status === "completed" ?
                                                                        <div
                                                                            className='h-100 w-100 d-flex justify-content-center align-items-center'
                                                                            style={{
                                                                                minHeight: 'calc(100dvh - 215px)'
                                                                            }}
                                                                        >
                                                                            <video
                                                                                controls
                                                                                src={callRecordingsArr[0]?.composed_recording[0]?.media_location}
                                                                                style={{
                                                                                    width: '100%',
                                                                                    height: 'calc(-215px + 100dvh)',
                                                                                    borderRadius: "12px",
                                                                                    objectFit: 'contain',
                                                                                }}
                                                                                autoPlay
                                                                            // loop
                                                                            />
                                                                        </div> :
                                                                        (callRecordingsArr[0]?.composed_recording[0]?.status === "enqueued" || callRecordingsArr[0]?.composed_recording[0]?.status === "processing") ?
                                                                            <span>{`Composition is in progress, please try after some time.`}</span> :
                                                                            callRecordingsArr[0]?.composed_recording[0]?.status === "failed" ?
                                                                                <span>{`Composition of this session is failed`}</span> : ''
                                                                    }
                                                                </> :
                                                                <>
                                                                    <>
                                                                        <div className='row mx-2 fs-6 py-2 my-5'>
                                                                            <div className='col-12 px-0 d-flex justify-content-center align-items-center flex-column'>
                                                                                <img src={emptyListImg} style={{ width: "70px" }} alt="" />
                                                                                <span className='mt-3 fs-5 text-center text-white fw-bold'>{"No video recordings found"}</span>
                                                                            </div>
                                                                        </div>
                                                                    </>
                                                                </>}

                                                        </div>
                                                    </div>
                                                </div>
                                            </> :
                                            localProTabs === 2 ?
                                                <>
                                                    <div className='row mt-2'>
                                                        <div className='col-12 px-0'>
                                                            <div className='row mx-0 overflow-auto pb-5'
                                                                style={{
                                                                    //  minHeight: "300px", 
                                                                    //  maxHeight: "300px",  

                                                                }}
                                                            >
                                                                <div className='col-12 px-0'>

                                                                    <>
                                                                        {attachmentsArr?.length > 0 ? (
                                                                            <div className="row mt-4 mx-5">
                                                                                {attachmentsArr?.map(
                                                                                    (data, index) => {
                                                                                        return (
                                                                                            <span
                                                                                                className="rounded-3 shadow"
                                                                                                style={{
                                                                                                    height: "170px",
                                                                                                    background: "grey",
                                                                                                    width: "120px",
                                                                                                    marginRight: "10px",
                                                                                                    marginBottom: "10px",
                                                                                                    border: '2px solid rgba(216, 122, 36, 1)'
                                                                                                }}
                                                                                            >
                                                                                                <span className="fs-6 py-1 w-100">
                                                                                                    <img
                                                                                                        src={data?.url}
                                                                                                        className="w-100 h-100 rounded-3 cursor-pointer"
                                                                                                        alt=""
                                                                                                        onClick={() => {
                                                                                                            handleOpenDoc();
                                                                                                            setImageAttachURL(data?.url)
                                                                                                        }}
                                                                                                    />
                                                                                                </span>
                                                                                            </span>
                                                                                        );
                                                                                    }
                                                                                )}
                                                                            </div>
                                                                        ) :
                                                                            <>
                                                                                <div className='row mx-2 fs-6 py-2 my-5'>
                                                                                    <div className='col-12 px-0 d-flex justify-content-center align-items-center flex-column'>
                                                                                        <img src={emptyListImg} style={{ width: "70px" }} alt="" />
                                                                                        <span className='mt-3 fs-5 text-center text-white fw-bold'>{"No attachments added yet"}</span>
                                                                                    </div>
                                                                                </div>
                                                                            </>
                                                                        }
                                                                    </>
                                                                </div>
                                                            </div>

                                                        </div>
                                                    </div>
                                                </> :
                                                localProTabs === 3 ?
                                                    <>
                                                        <div className='row mt-2'>
                                                            <div className='col-12 px-0'>
                                                                <div className='row mx-0 overflow-auto pb-5'
                                                                    style={{
                                                                        //  minHeight: "300px", 
                                                                        //  maxHeight: "300px",  

                                                                    }}
                                                                >
                                                                    <div className='col-12 px-0'>

                                                                        {callNoteDetailsArr.length > 0 ?
                                                                            <>
                                                                                {
                                                                                    callNoteDetailsArr.map((element, index) => {
                                                                                        return (
                                                                                            <div key={index} className='row px-3 fs-6 border-bottom py-2 '>
                                                                                                <div className='col-12 px-0 d-flex'>

                                                                                                    <div className='pe-3 d-flex justify-content-center'>
                                                                                                        <div>
                                                                                                            <div className='rounded-2 shadow-lg'>
                                                                                                                <div
                                                                                                                    className='rounded-2 d-flex justify-content-center align-items-center'
                                                                                                                    style={{ height: '40px', width: '40px', background: 'rgba(79, 93, 116, 1)' }}
                                                                                                                >
                                                                                                                    {element?.preferred_profile_picture_url ?
                                                                                                                        <img src={element?.preferred_profile_picture_url} alt="Avatar" className="rounded-2" style={{ height: '40px', width: '40px' }} /> :
                                                                                                                        <i className="bi bi-file-earmark-image-fill fs-3 text-white"></i>
                                                                                                                    }
                                                                                                                </div>
                                                                                                            </div>
                                                                                                        </div>
                                                                                                    </div>

                                                                                                    <div className='w-100'>
                                                                                                        <div className='row mx-0 mb-1'>
                                                                                                            <div className='col-12 px-0  font-w500'>
                                                                                                                <span className='text-white pe-2'>{`${element?.created_by_name}`}</span>
                                                                                                                <span className='fs-7 text-white'>{`${formatUnixTimestamp(element?.created_date_dtm)}`}</span>
                                                                                                            </div>

                                                                                                        </div>

                                                                                                        <div className='row mx-0 mb-1'>
                                                                                                            <div className='col-12 px-0 d-flex justify-content-start font-w500'>
                                                                                                                <span className='text-white pe-3'>
                                                                                                                    {`${element?.note_chr}`}
                                                                                                                </span>
                                                                                                            </div>
                                                                                                        </div>

                                                                                                        <div className='row mx-0 mb-1'>
                                                                                                            <div
                                                                                                                className='col-12 px-0 d-flex '
                                                                                                                style={{ overflow: 'auto', }}
                                                                                                            >
                                                                                                                {element?.attachment_url.map((elem, ind) => {
                                                                                                                    return (
                                                                                                                        <span className='call-notes-individual-img-download-span' key={index}>

                                                                                                                            <img
                                                                                                                                className='call-notes-individual-img-download'
                                                                                                                                src={elem}
                                                                                                                                alt='Error'
                                                                                                                                title='Download'
                                                                                                                                onClick={() => {
                                                                                                                                    handleOpenDoc();
                                                                                                                                    setImageAttachURL(elem);
                                                                                                                                    setNotesMessage(element?.note_chr)
                                                                                                                                }}
                                                                                                                                style={{ cursor: 'pointer' }}
                                                                                                                            />

                                                                                                                        </span>
                                                                                                                    )
                                                                                                                })}
                                                                                                            </div>
                                                                                                        </div>
                                                                                                    </div>

                                                                                                </div>
                                                                                            </div>
                                                                                        )
                                                                                    })
                                                                                }
                                                                            </> :

                                                                            <div className='row mx-2 fs-6 py-2 my-5'>
                                                                                <div className='col-12 px-0 d-flex justify-content-center align-items-center flex-column'>
                                                                                    <img src={emptyListImg} style={{ width: "70px" }} alt="" />
                                                                                    <span className='mt-3 fs-5 text-center text-white fw-bold'>{"No notes added yet"}</span>
                                                                                </div>
                                                                            </div>
                                                                        }
                                                                    </div>
                                                                </div>

                                                            </div>
                                                        </div>
                                                    </> :
                                                    <></>
                                    }


                                </div>

                            </div>
                        </div>

                        <div className='col-sm-12 col-lg-3 ' style={{ minHeight: 'calc(100vh - 93px)' }}>
                            <div className='rounded-2 bg-white  h-100 p-2'>
                                <div className='row mb-3'>
                                    <div
                                        className='col-12 d-flex justify-content-between align-items-center'
                                        style={{
                                            pointerEvents: serviceId ? 'auto' : 'none',
                                            // cursor: serviceId ? 'pointer' : 'not-allowed',
                                            opacity: serviceId ? '1' : '0.5',
                                        }}
                                    >
                                        <span
                                            className='fs-5 font-w600 text-white px-2 py-3 rounded-2 bg-orange rounded-2 text-center cursor-pointer h-100 d-flex justify-content-center align-items-center'
                                            style={{
                                                width: '33%',
                                                pointerEvents: (bidStatus != 1 && bidStatus != 4) ? 'auto' : 'none',
                                                cursor: (bidStatus != 1 && bidStatus != 4) ? 'pointer' : 'not-allowed',
                                                opacity: (bidStatus != 1 && bidStatus != 4) ? '1' : '0.5',
                                            }}
                                            onClick={() => {
                                                if (isVerified) {
                                                    handelOpenCreateBidModal();
                                                } else {
                                                    handleSuperAdminApproveMessage();
                                                }
                                            }}
                                        >
                                            {`Bid on Job`}
                                        </span>

                                        <span
                                            className='fs-5 font-w600 text-black px-2 py-3 rounded-2 border mx-2 rounded-2 text-center cursor-pointer h-100 d-flex justify-content-center align-items-center'
                                            style={{
                                                width: '33%',
                                            }}
                                            onClick={() => {
                                                if (isVerified) {
                                                    handleOpenAskQuestionModal();
                                                } else {
                                                    handleSuperAdminApproveMessage();
                                                }
                                            }}
                                        >
                                            {`Ask Question`}
                                        </span>

                                        <span
                                            className='fs-5 font-w600 text-danger px-2 py-3 rounded-2 border border-danger rounded-2 text-center cursor-pointer h-100 d-flex justify-content-center align-items-center'
                                            style={{
                                                width: '33%',
                                                backgroundColor: 'rgba(255, 0, 0, 0.1)',
                                                pointerEvents: 'none',
                                                opacity: '0.5',
                                            }}
                                            onClick={() => {
                                                if (isVerified) {
                                                    setHideServiceRequestModalTrigger(true);
                                                } else {
                                                    handleSuperAdminApproveMessage();
                                                }
                                            }}
                                        >
                                            {`Decline`}
                                        </span>
                                    </div>
                                </div>

                                <div
                                    className='overflow-auto'
                                    style={{
                                        maxHeight: 'calc(100dvh - 191px)'
                                    }}
                                >
                                    <div className='row mb-3'>
                                        <div className='col-12 rounded-2 border'>
                                            <div
                                                className='text-black fs-5 font-w600 p-2 mb-2 rounded-top'
                                                style={{
                                                    background: '#80808085'
                                                }}
                                            >
                                                <span>{`📋 Estimate Summary`}</span>
                                            </div>

                                            <div className='row p-2 border-bottom'>
                                                <div className='col-4'>
                                                    <span className=' font-w500'>{`Diagnosis`}</span>
                                                </div>
                                                <div className='col-8'>
                                                    <span className=' font-w500 text-black'>
                                                        {serviceSummaryMetaData?.pro_check_info?.pro_diagnosis ?
                                                            serviceSummaryMetaData?.pro_check_info?.pro_diagnosis :
                                                            `-`}
                                                    </span>
                                                </div>
                                            </div>

                                            <div className='row p-2 border-bottom'>
                                                <div className='col-4'>
                                                    <span className=' font-w500'>{`Est. Cost`}</span>
                                                </div>
                                                <div className='col-8'>
                                                    <span className=' font-w500 text-orange'>
                                                        {serviceSummaryMetaData?.pro_check_info?.pro_estimated_cost_min &&
                                                            <>
                                                                <span>
                                                                    {serviceSummaryMetaData?.pro_check_info?.pro_estimated_cost_min ?
                                                                        USDollar.format(parseFloat(serviceSummaryMetaData.pro_check_info.pro_estimated_cost_min.toFixed(2))) :
                                                                        ``}
                                                                </span>
                                                                <span>{` - `}</span>
                                                                <span>
                                                                    {serviceSummaryMetaData?.pro_check_info?.pro_estimated_cost_max ?
                                                                        USDollar.format(parseFloat(serviceSummaryMetaData.pro_check_info.pro_estimated_cost_max.toFixed(2))) : ``}
                                                                </span>

                                                            </>}
                                                    </span>
                                                </div>
                                            </div>



                                            <div className='row p-2 border-bottom'>
                                                <div className='col-4'>
                                                    <span className=' font-w500'>{`Requested`}</span>
                                                </div>
                                                <div className='col-8'>
                                                    <span className=' font-w500 text-black'>
                                                        {`${serviceSummaryMetaData?.estimated_by_customer?.date ? `by ${serviceSummaryMetaData?.estimated_by_customer?.date}, ${serviceSummaryMetaData?.estimated_by_customer?.time}` : 'ASAP'} `}
                                                    </span>
                                                </div>
                                            </div>

                                            <div className='row p-2 '>
                                                <div className='col-4'>
                                                    <span className=' font-w500'>{`Summary`}</span>
                                                </div>
                                                <div className='col-8'>
                                                    <span className=' font-w500 text-black'>
                                                        {serviceSummaryMetaData?.recognized_image_summary ? serviceSummaryMetaData?.recognized_image_summary : `-`}
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className='row mb-3'>
                                        <div className='col-12 rounded-2 border'>
                                            <div
                                                className='text-black fs-5 font-w600 p-2 mb-2 rounded-top'
                                                style={{
                                                    background: '#80808085'
                                                }}
                                            >
                                                <span>{`🔧 Device Info`}</span>
                                            </div>

                                            <div className='row p-2 border-bottom'>
                                                <div className='col-4'>
                                                    <span className=' font-w500'>{`Type`}</span>
                                                </div>
                                                <div className='col-8'>
                                                    <span className=' font-w500 text-black'>
                                                        {receiverData.product_type_chr ? `${receiverData.product_type_chr}` : ''}
                                                    </span>
                                                </div>
                                            </div>




                                            <div className='row p-2 border-bottom'>
                                                <div className='col-4'>
                                                    <span className=' font-w500'>{`Brand`}</span>
                                                </div>
                                                <div className='col-8'>
                                                    <span className=' font-w500 text-black'>
                                                        {`${brandName ? `${brandName}` : "-"}`}
                                                    </span>
                                                </div>
                                            </div>

                                            <div className='row p-2 '>
                                                <div className='col-4'>
                                                    <span className=' font-w500'>{`Model`}</span>
                                                </div>
                                                <div className='col-8'>
                                                    <span className=' font-w500 text-black'>
                                                        {`${modelNum ? `${modelNum}` : "-"}`}
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className='row mb-3'>
                                        <div className='col-12 rounded-2 border'>
                                            <div
                                                className='text-black fs-5 font-w600 p-2 mb-2 rounded-top'
                                                style={{
                                                    background: '#80808085'
                                                }}
                                            >
                                                <span>{`📍 Customer Location`}</span>
                                            </div>

                                            <div className='row p-2 border-bottom'>
                                                <div className='col-4'>
                                                    <span className=' font-w500'>{`Zip Code`}</span>
                                                </div>
                                                <div className='col-8'>
                                                    <span className=' font-w500 text-black'>
                                                        {bidStatus == "4" ? `${receiverData.creator_zip_code_int}` : "-"}
                                                    </span>
                                                </div>
                                            </div>

                                            <div className='row p-2'>

                                                {bidStatus == "4" ?
                                                    <>
                                                        <div className='col-4'>
                                                            <span className=' font-w500'>{`Address`}</span>
                                                        </div>
                                                        <div className='col-8'>
                                                            <span className=' font-w500 text-black'>{`${receiverData.complete_address_chr}`}</span>
                                                        </div>
                                                    </> : <>
                                                        <div className='col-4'>
                                                            <span className=' font-w500'>{`Note`}</span>
                                                        </div>
                                                        <div className='col-8'>
                                                            <span className=' font-w500 text-black'>{`Full address revealed after accepting.`}</span>
                                                        </div>
                                                    </>
                                                }

                                            </div>
                                        </div>
                                    </div>


                                </div>
                            </div>
                        </div>

                    </div>

                </div>
            </div>

            {/* Connect to Local Pro modal */}
            <>
                {/* <!-- Modal --> */}
                <Modal className="fade" show={createBidModalTrigger}
                    // onHide={handleClose} 
                    centered
                    size=""

                >
                    <Modal.Body
                        style={{
                            // background: 'linear-gradient(182deg, rgba(250, 238, 227, 0.67) 33%, rgb(255, 255, 255) 85%)',
                            borderRadius: '8px',
                        }}
                    >
                        <>
                            <div className='row mx-0'>
                                <div className='col-12 px-0'>

                                    <div className='row mx-0'>
                                        <div className='col-12 px-0 d-flex align-items-center justify-content-end fs-4 text-black'>
                                            <span onClick={() => handelCloseCreateBidModal()} className='cursor-pointer'>
                                                <i className="bi bi-x-lg"></i>
                                            </span>
                                        </div>
                                    </div>

                                    <>
                                        <>
                                            <div className='row mx-0'>
                                                <div className='fw-bold col-12 px-0 d-flex align-items-center fs-3 text-black justify-content-center'>
                                                    <span className=''>
                                                        {"Submit Bid"}
                                                    </span>
                                                </div>
                                            </div>

                                            <div
                                                className='row mx-0 mt-3 pb-2'
                                                style={{
                                                    borderBottom: '4px solid rgb(250, 239, 230)'
                                                }}
                                            >
                                                <div className='font-w500 col-12 px-0 d-flex align-items-center fs-5 '>
                                                    <span className=' text-black font-w600'>
                                                        {`${receiverData.category_display_name_chr ? `${receiverData.category_display_name_chr} :` : ''}
                                                        ${receiverData.product_type_chr ? `${receiverData.product_type_chr}` : ''}
                                                        `}

                                                        {`-- ${receiverData.problem_description_chr ? receiverData.problem_description_chr : 'Problem description not specified'}`}
                                                    </span>
                                                </div>
                                            </div>



                                            <form className='w-100' onSubmit={(e) => {
                                                handleSubmitCreateBid(e);
                                            }}>

                                                <div className="row mt-3">

                                                    <div className='col-12 px-0 '>
                                                        <div
                                                            className='d-flex align-items-center justify-content-between'
                                                            style={{
                                                            }}
                                                        >
                                                            <div className="w-100" style={{}}>
                                                                <InputField
                                                                    labelName={"Bid Price ($)"}
                                                                    placeholderName={"Bid Price ($)"}
                                                                    value={`${bidPriceMax}`}
                                                                    onChange={(e) => { handleBidPriceMax(e) }}
                                                                    onBlur={() => { }}
                                                                    errorOccured={isBidPriceError}
                                                                    errorMeesage={"Please add Bid Price"}
                                                                    isRequired={true}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className='row mx-0 '>
                                                    <div className='font-w600 text-black col-12 px-0 d-flex align-items-center fs-5 '>
                                                        <div className='d-flex align-items-center mb-2'>

                                                            <span className=' text-center'>
                                                                {"Proposed arrival"}
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className='row mx-0 '>
                                                    <div className='row mt-1'>
                                                        <div className='col-12 px-0' >
                                                            <div className="d-flex align-items-center mt-2">

                                                                <span
                                                                    className=' pt-1 w-100'
                                                                >
                                                                    <div className='col-12 px-0 '>

                                                                        <div className='d-flex align-items-center justify-content-between'>


                                                                            <div className="" style={{ width: '45%', }}>

                                                                                <InputField
                                                                                    type="date"
                                                                                    labelName={"Date"}
                                                                                    placeholder={"Date"}
                                                                                    value={currentDateLocalPro}
                                                                                    onChange={(e) => setCurrentDateLocalPro(e.target.value)}
                                                                                    errorOccured={false}
                                                                                    errorMeesage={"Please enter date"}
                                                                                    onBlur={() => { }}
                                                                                />
                                                                            </div>

                                                                            <div
                                                                                className='p-2 px-1 d-flex align-items-center justify-content-center'
                                                                            >
                                                                                <span className='font-w600 text-black fs-6 mb-3'> {`near`}</span>
                                                                            </div>

                                                                            <div className="" style={{ width: '45%', }}>
                                                                                <InputField
                                                                                    type="time"
                                                                                    labelName={"Time"}
                                                                                    placeholder={"Date and time"}
                                                                                    value={currentTimeLocalPro}
                                                                                    onChange={(e) => {
                                                                                        setCurrentTimeLocalPro(e.target.value)
                                                                                    }}
                                                                                    errorOccured={false}
                                                                                    errorMeesage={""}
                                                                                    onBlur={() => { }}
                                                                                />
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </span>
                                                            </div>
                                                            {/* {termsAndConditionsErr &&
                                                                <div className='mt-2 text-danger fs-12'>
                                                                    <span>{`Please accept the Terms & Conditions`}</span>
                                                                </div>
                                                            } */}
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className='row mx-0 mt-2'>
                                                    <div className='col-12 px-0'>
                                                        <TextArea
                                                            onChange={(e) => { handleBidNotes(e) }}
                                                            value={bidNotes}
                                                            labelName={"Bid notes *"}
                                                            errorOccured={isBidNotesError}
                                                            errorMessage={"Please provide bid note"}
                                                            rows={'3'}
                                                            onBlur={() => { }}
                                                        />
                                                    </div>
                                                </div>

                                                <div className='row mx-0'>
                                                    <div className='row'>
                                                        <div className='col-12 px-0' >
                                                            <div className="d-flex align-items-center">
                                                                <input
                                                                    type="checkbox"
                                                                    className="form-check-input"
                                                                    id="refund"
                                                                    name="refund"
                                                                    onChange={(e) => {
                                                                        setTermsAndConditions(!termsAndConditions);
                                                                        setTermsAndConditionsErr(false)
                                                                    }}
                                                                    value={termsAndConditions}
                                                                    checked={termsAndConditions}
                                                                />
                                                                <span
                                                                    className='ps-3 pt-1 text-black fs-5'
                                                                >
                                                                    {`Agree to`}
                                                                    <strong className='text-hovered cursor-pointer ps-1' >
                                                                        <a
                                                                            className="terms-condition-link"
                                                                            href="https://chilll.com/chilll-terms-conditions/"
                                                                            target="_blank"
                                                                            rel="noreferrer">
                                                                            {"Terms and Conditions "}
                                                                        </a>
                                                                    </strong>
                                                                </span>
                                                            </div>
                                                            {termsAndConditionsErr &&
                                                                <div className='mt-2 text-danger fs-12'>
                                                                    <span>{`Please accept the Terms & Conditions`}</span>
                                                                </div>
                                                            }
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className='row mx-0 mt-3'>
                                                    <div className='font-w500 col-12 px-0 d-flex align-items-center justify-content-center fs-5 '>
                                                        <PrimaryButton
                                                            buttonName={"SUBMIT"}
                                                            onClick={(e) => {
                                                                handleSubmitCreateBid(e);
                                                                // handleCloseLocalProModal(e);
                                                            }}
                                                            loadingMessage={"Submitting..."}
                                                            isLoading={createBidLoading}
                                                            style={{
                                                                width: '100%',
                                                                background: 'linear-gradient(142.98deg, #FF7401 1.99%, #FFA800 99.97%)',
                                                                border: '2px solid rgba(255, 154, 32, 1)',
                                                                boxShadow: '0px 6px 12px 0px rgba(255, 154, 32, 0.24)',
                                                                fontWeight: '600',
                                                            }}
                                                        />
                                                    </div>
                                                </div>
                                            </form>
                                        </>
                                    </>

                                </div>
                            </div>
                        </>
                    </Modal.Body>
                </Modal>
            </>

            {/* Ask questions modal */}
            <>
                {/* <!-- Modal --> */}
                <Modal className="fade" show={askQuestionModalTrigger}
                    // onHide={handleClose} 
                    centered
                    size=""

                >
                    <Modal.Body
                        style={{
                            // background: 'linear-gradient(182deg, rgba(250, 238, 227, 0.67) 33%, rgb(255, 255, 255) 85%)',
                            borderRadius: '8px',
                        }}
                    >
                        <>
                            <div className='row mx-0'>
                                <div className='col-12 px-0'>

                                    <div className='row mx-0'>
                                        <div className='col-12 px-0 d-flex align-items-center justify-content-between fs-4 text-black'>
                                            <div>
                                                {tabsToggleForAskQuestion == 2 ?
                                                    <div
                                                        onClick={() => {
                                                            setTabsToggleForAskQuestion(1);
                                                        }}
                                                        className="cursor-pointer"
                                                    >
                                                        <i className="bi bi-arrow-left "></i>
                                                        <span className="ps-2">Back</span>
                                                    </div> :
                                                    tabsToggleForAskQuestion == 3 ?
                                                        <div
                                                            onClick={() => {
                                                                setTabsToggleForAskQuestion(2);
                                                                setTicketThreadObj({});
                                                            }}
                                                            className="cursor-pointer"
                                                        >
                                                            <i className="bi bi-arrow-left "></i>
                                                            <span className="ps-2">Back</span>
                                                        </div> :
                                                        tabsToggleForAskQuestion == 4 ?
                                                            <div
                                                                onClick={() => {
                                                                    setTabsToggleForAskQuestion(2);
                                                                    setTicketThreadObj({});
                                                                    setQuestionDescription('');
                                                                }}
                                                                className="cursor-pointer"
                                                            >
                                                                <i className="bi bi-arrow-left "></i>
                                                                <span className="ps-2">Back</span>
                                                            </div> : <></>
                                                }
                                            </div>

                                            <span onClick={() => handleCloseAskQuestionModal()} className='cursor-pointer'>
                                                <i className="bi bi-x-lg"></i>
                                            </span>
                                        </div>
                                    </div>

                                    <>

                                        {tabsToggleForAskQuestion == 1 ?
                                            <>
                                                <div className='row mx-0'>
                                                    <div className='fw-bold col-12 mb-3 px-0 d-flex align-items-center fs-3 text-black justify-content-center'>
                                                        <span className=''>
                                                            {"Ask a Question"}
                                                        </span>
                                                    </div>
                                                </div>

                                                <div
                                                    className='row mx-0 pb-2'
                                                    style={{
                                                        borderBottom: '4px solid rgb(250, 239, 230)'
                                                    }}
                                                >
                                                    <div className='font-w500 col-12 px-0 d-flex align-items-center fs-5 '>
                                                        <span className=' text-black font-w600'>
                                                            {`${receiverData.category_display_name_chr ? `${receiverData.category_display_name_chr} :` : ''}
                                                        ${receiverData.product_type_chr ? `${receiverData.product_type_chr}` : ''}
                                                        `}

                                                            {`-- ${receiverData.problem_description_chr ? receiverData.problem_description_chr : 'Problem description not specified'}`}
                                                        </span>
                                                    </div>
                                                </div>

                                                <div className='row'>
                                                    <div className='col-12 mx-0'>
                                                        <div className='d-flex align-items-center justify-content-end fs-5 text-black mt-3 mb-2'>
                                                            <span
                                                                className='font-w600 cursor-pointer text-decoration-underline text-hovered'
                                                                onClick={() => {
                                                                    setTabsToggleForAskQuestion(2);
                                                                    handleGetTicketMessageThread();
                                                                }}
                                                            >
                                                                {`Previous conversations`}
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>



                                                <form className='w-100' onSubmit={(e) => {
                                                    handleCreateTicketThread(e);
                                                }}>
                                                    <div className='row mx-0 mt-4'>
                                                        <div className='col-12 px-0'>
                                                            <TextArea
                                                                onChange={(e) => { handleQuestionDescription(e) }}
                                                                value={questionDescription}
                                                                labelName={"Your Question *"}
                                                                errorOccured={questionDescriptionErr}
                                                                errorMessage={"Please provide a question description"}
                                                                placeholder={"e.g. Can you provide the error code?"}
                                                                rows={'3'}
                                                                onBlur={() => { }}
                                                            />
                                                        </div>
                                                    </div>

                                                    <div className='row mx-0 mt-3'>
                                                        <div className='font-w500 col-12 px-0 d-flex align-items-center justify-content-center fs-5 '>
                                                            <PrimaryButton
                                                                buttonName={"SUBMIT"}
                                                                onClick={(e) => {
                                                                    handleCreateTicketThread(e);
                                                                    // handleCloseLocalProModal(e);
                                                                }}
                                                                loadingMessage={"Submitting..."}
                                                                isLoading={createTicketThreadLoading}
                                                                style={{
                                                                    width: '100%',
                                                                    background: 'linear-gradient(142.98deg, #FF7401 1.99%, #FFA800 99.97%)',
                                                                    border: '2px solid rgba(255, 154, 32, 1)',
                                                                    boxShadow: '0px 6px 12px 0px rgba(255, 154, 32, 0.24)',
                                                                    fontWeight: '600',
                                                                }}
                                                            />
                                                        </div>
                                                    </div>
                                                </form>
                                            </> :
                                            tabsToggleForAskQuestion == 2 ?
                                                <>
                                                    <div className='row mx-0 mb-3'>
                                                        <div className='fw-bold col-12 px-0 d-flex align-items-center fs-3 text-black justify-content-center'>
                                                            <span className=''>
                                                                {"Conversations"}
                                                            </span>
                                                        </div>
                                                    </div>

                                                    {getTicketMessageThreadLoading ?
                                                        <>
                                                            {[...Array(5)].map((data, id) => {
                                                                return (
                                                                    <>
                                                                        <div key={id} className="row mx-1 shadow bg-white my-2 mt-3" style={{ height: "", borderRadius: '16px' }}>
                                                                            <div className="col-12 d-flex p-2">
                                                                                <div className="w-100 h-100 d-flex flex-column justify-content-between ms-3">
                                                                                    <div className="d-flex align-items-center justify-content-between mb-2">
                                                                                        <div>
                                                                                            <SkeletonDivElement height={'20px'} width={'90px'} borderRadius={'14px'} />
                                                                                        </div>

                                                                                        <div>
                                                                                            <SkeletonDivElement height={'20px'} width={'90px'} borderRadius={'14px'} />
                                                                                        </div>
                                                                                    </div>

                                                                                    <div>
                                                                                        <div className="mb-2">
                                                                                            <SkeletonDivElement height={'20px'} width={'30%'} borderRadius={'14px'} />
                                                                                        </div>

                                                                                        <div className="mb-2">
                                                                                            <SkeletonDivElement height={'20px'} width={'50%'} borderRadius={'14px'} />
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </>
                                                                )
                                                            })}
                                                        </> :
                                                        <>
                                                            {ticketMessageThreadArr?.length > 0 ?
                                                                <>
                                                                    <div
                                                                        className='w-100 overflow-auto'
                                                                        style={{ maxHeight: '60dvh' }}
                                                                    >
                                                                        {ticketMessageThreadArr?.map((element, index) => {

                                                                            return (
                                                                                <>
                                                                                    <div key={index} className='row  fs-6 border-bottom p-4 rounded-3 rounded-3 bg-light mb-2'>
                                                                                        <div className='col-12 px-0 d-flex'>

                                                                                            {/* <div className='pe-3 d-flex justify-content-center'>
                                                                                        <div>
                                                                                            <div className='rounded-2 shadow-lg'>
                                                                                                <div
                                                                                                    className='rounded-2 d-flex justify-content-center align-items-center'
                                                                                                    style={{ height: '40px', width: '40px', background: 'rgba(79, 93, 116, 1)' }}
                                                                                                >
                                                                                                    {element?.preferred_profile_picture_url ?
                                                                                                        <img src={element?.preferred_profile_picture_url} alt="Avatar" className="rounded-2" style={{ height: '40px', width: '40px' }} /> :
                                                                                                        <i className="bi bi-file-earmark-image-fill fs-3 text-white"></i>
                                                                                                    }
                                                                                                </div>
                                                                                            </div>
                                                                                        </div>
                                                                                    </div> */}

                                                                                            <div className='w-100'>
                                                                                                <div className='row mx-0 mb-1'>


                                                                                                    <div className='col-12 px-0 d-flex justify-content-between mb-2 align-items-center'>
                                                                                                        <div>
                                                                                                            <span className='text-black font-w600'>
                                                                                                                {`${element?.first_name_chr} (${element?.role_display_name_chr})`}
                                                                                                            </span>
                                                                                                        </div>

                                                                                                        {localStorage.getItem("user_id") == element?.created_by_chr &&
                                                                                                            <div className='d-flex'>
                                                                                                                <span
                                                                                                                    className='text-success me-2 bg-white rounded-circle d-flex justify-content-center align-items-center cursor-pointer overlay-action-btn'
                                                                                                                    style={{ height: '35px', width: '35px' }}
                                                                                                                    onClick={(e) => {
                                                                                                                        e.stopPropagation();
                                                                                                                        setTicketThreadObj(element);
                                                                                                                        setQuestionDescription(element?.message_body_chr);
                                                                                                                        setTabsToggleForAskQuestion(4);
                                                                                                                        setQuestionDescriptionErr(false);
                                                                                                                    }}
                                                                                                                >
                                                                                                                    <i className={`bi bi-pencil`} style={{ fontSize: '18px' }}></i>
                                                                                                                </span>

                                                                                                                <span
                                                                                                                    className='text-danger  bg-white rounded-circle d-flex justify-content-center align-items-center cursor-pointer overlay-action-btn'
                                                                                                                    style={{ height: '35px', width: '35px' }}
                                                                                                                    onClick={(e) => {
                                                                                                                        e.stopPropagation();
                                                                                                                        setTabsToggleForAskQuestion(3);
                                                                                                                        setTicketThreadObj(element);
                                                                                                                    }}
                                                                                                                >
                                                                                                                    <i className={`bi bi-trash3-fill`} style={{ fontSize: '18px' }}></i>
                                                                                                                </span>
                                                                                                            </div>
                                                                                                        }
                                                                                                    </div>
                                                                                                </div>

                                                                                                <div className='row mx-0 mb-1'>
                                                                                                    <div className='col-12 px-0 d-flex justify-content-start font-w500 flex-column'>
                                                                                                        <span className=''>
                                                                                                            {`${element?.message_body_chr || ''}`}
                                                                                                        </span>
                                                                                                    </div>
                                                                                                </div>

                                                                                                <div className='d-flex flex-column'>
                                                                                                    <span className=' text-black font-w600'>
                                                                                                        Date & Time:
                                                                                                        {/* {`${formatUnixTimestamp(element?.created_date_dtm)}`} */}
                                                                                                        {new Intl.DateTimeFormat("en-US", {
                                                                                                            year: "numeric",
                                                                                                            month: "short",
                                                                                                            day: "numeric",
                                                                                                            hour: 'numeric',
                                                                                                            minute: 'numeric',
                                                                                                            hour12: true
                                                                                                        }).format(
                                                                                                            element?.created_date_dtm * 1000
                                                                                                        )}
                                                                                                    </span>
                                                                                                </div>
                                                                                            </div>

                                                                                        </div>
                                                                                    </div>
                                                                                </>
                                                                            );
                                                                        })}
                                                                    </div>
                                                                </> :
                                                                <>
                                                                    <div className="mb-3 mt-4 d-flex justify-content-center align-items-center flex-column">
                                                                        <div className="mb-2">
                                                                            <img src={emptyListImg} alt="search" style={{ width: "70px" }} />
                                                                        </div>
                                                                        <span>
                                                                            {`No conversations yet`}
                                                                        </span>
                                                                    </div>
                                                                </>
                                                            }
                                                        </>
                                                    }
                                                </> :
                                                tabsToggleForAskQuestion == 3 ?
                                                    <>
                                                        <div className="row mx-0 mb-4">
                                                            <div className="fw-bold col-12 px-0 d-flex align-items-center justify-content-center fs-3 text-black">
                                                                <span className="">{"Delete note"}</span>
                                                            </div>
                                                        </div>

                                                        <div className="row mx-0 mb-4 pb-2">
                                                            <div className="col-12 px-0 font-w600 d-flex justify-content-center align-items-center">
                                                                <span className="fs-5">
                                                                    {"Are you sure you want to delete this note?"}
                                                                </span>
                                                            </div>
                                                        </div>

                                                        <div className="row mx-0 text-black">
                                                            <div className="col-12 font-w600">
                                                                <PrimaryButton
                                                                    onClick={(e) => { handleDeleteTicketThreadById() }}
                                                                    buttonName={"YES, DELETE IT"}
                                                                    loadingMessage={"Deleting..."}
                                                                    isLoading={deleteTicketThreadLoading}
                                                                    style={{
                                                                        width: "100%",
                                                                        background: 'linear-gradient(142.98deg, #E02D2D 1.99%, #FF5C5C 99.97%)',
                                                                        boxShadow: '0px 6px 12px 0px rgba(240, 72, 72, 0.24)',
                                                                        border: '1px solid rgba(240, 72, 72, 1)',
                                                                    }}
                                                                />
                                                            </div>
                                                        </div>
                                                    </> :
                                                    tabsToggleForAskQuestion == 4 ?
                                                        <>
                                                            <div className='row mx-0'>
                                                                <div className='fw-bold col-12 mb-3 px-0 d-flex align-items-center fs-3 text-black justify-content-center'>
                                                                    <span className=''>
                                                                        {"Edit Message"}
                                                                    </span>
                                                                </div>
                                                            </div>

                                                            <form
                                                                className='w-100'
                                                                onSubmit={(e) => {
                                                                    handleUpdateTicketThreadById(e);
                                                                }}
                                                            >
                                                                <div className='row mx-0 mt-4'>
                                                                    <div className='col-12 px-0'>
                                                                        <TextArea
                                                                            onChange={(e) => { handleQuestionDescription(e) }}
                                                                            value={questionDescription}
                                                                            labelName={"Your Question *"}
                                                                            errorOccured={questionDescriptionErr}
                                                                            errorMessage={"Please provide a question description"}
                                                                            placeholder={"e.g. Can you provide the error code?"}
                                                                            // rows={'3'}
                                                                            onBlur={() => { }}
                                                                        />
                                                                    </div>
                                                                </div>

                                                                <div className='row mx-0 mt-3'>
                                                                    <div className='font-w500 col-12 px-0 d-flex align-items-center justify-content-center fs-5 '>
                                                                        <PrimaryButton
                                                                            buttonName={"SUBMIT"}
                                                                            onClick={(e) => {
                                                                                handleUpdateTicketThreadById(e);
                                                                            }}
                                                                            loadingMessage={"Submitting..."}
                                                                            isLoading={createTicketThreadLoading}
                                                                            style={{
                                                                                width: '100%',
                                                                                background: 'linear-gradient(142.98deg, #FF7401 1.99%, #FFA800 99.97%)',
                                                                                border: '2px solid rgba(255, 154, 32, 1)',
                                                                                boxShadow: '0px 6px 12px 0px rgba(255, 154, 32, 0.24)',
                                                                                fontWeight: '600',
                                                                            }}
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </form>
                                                        </> : <></>
                                        }
                                    </>

                                </div>
                            </div>
                        </>
                    </Modal.Body>
                </Modal>
            </>

            {/* Modal for delete notes starts */}
            <Modal
                className="fade"
                show={hideServiceRequestModalTrigger}
                // onHide={handleClose}
                centered>
                <Modal.Body>
                    <div className="row mx-0">
                        <div className="col-12 px-0">
                            <div className="row mx-0">
                                <div className="col-12 px-0 d-flex align-items-center justify-content-end fs-4 text-black">
                                    <span
                                        onClick={() => setHideServiceRequestModalTrigger(false)}
                                        className="cursor-pointer">
                                        <i className="bi bi-x-lg"></i>
                                    </span>
                                </div>
                            </div>

                            <div className="row mx-0 mb-3">
                                <div className="fw-bold col-12 px-0 d-flex align-items-center justify-content-center fs-3 text-black">
                                    <span className="">{"Decline Service"}</span>
                                </div>
                            </div>

                            <div className="row mx-0 mt-3 pb-2">
                                <div className="col-12 px-0 font-w600 d-flex justify-content-center align-items-center">
                                    <span className="fs-5">
                                        {"Are you sure you want to Decline this service request?"}
                                    </span>
                                </div>
                            </div>

                            {/* <div className="row mx-0 text-black mt-2">
                                            <div className="col-12 px-0 font-w600">
                                                <PrimaryButton
                                                    onClick={(e) => handleCloseModalNotes()}
                                                    buttonName={"Cancel"}
                                                    style={{
                                                        width: "100%",
                                                        backgroundColor: "white",
                                                        border: "none",
                                                        color: "grey",
                                                    }}
                                                />
                                            </div>
                                        </div> */}

                            <div className="row mx-0 text-black mt-2">
                                <div className="col-sm-6 pe-sm-2 font-w600">
                                    <PrimaryButton
                                        onClick={(e) => setHideServiceRequestModalTrigger(false)}
                                        buttonName={"CANCEL"}
                                        style={{
                                            width: "100%",
                                            background: 'rgba(251, 252, 255, 1)',
                                            border: '1px solid rgba(199, 212, 234, 1)',
                                            color: "black",
                                            boxShadow: '0px 6px 12px 0px rgba(102, 129, 172, 0.12)',
                                            fontWeight: '600',
                                        }}
                                    />
                                </div>

                                <div className="col-sm-6 ps-sm-2 font-w600">
                                    <PrimaryButton
                                        onClick={(e) => hideSeriveRequestFn()}
                                        buttonName={"YES, DECLINE IT"}
                                        loadingMessage={"Declining..."}
                                        isLoading={hideServiceRequestLoading}
                                        style={{
                                            width: "100%",
                                            background: 'linear-gradient(142.98deg, #E02D2D 1.99%, #FF5C5C 99.97%)',
                                            boxShadow: '0px 6px 12px 0px rgba(240, 72, 72, 0.24)',
                                            border: '1px solid rgba(240, 72, 72, 1)',
                                            fontWeight: '600',
                                        }}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>

            {handleToaster && <ResponceToaster toasterType={toasterType} message={responceMsg} />}

            {/* Modal for previewing the attached image preview */}
            {openDoc &&
                <ImagePreviewer
                    openDoc={openDoc}
                    handleCloseDoc={handleCloseDoc}
                    imageAttachURL={imageAttachURL}
                    notesMessage={notesMessage}
                />
            }
        </>
    )
}

export default LocalProDashboard;